export const otpIds = {
  signContracts: 'sign-contracts',
  updateUserMainContacts: 'update-user-main-contacts',
};
